/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
export enum BundleInformationTableColumnEnum {
    TOTAL_VALUE = 'TOTAL_VALUE',
}
